import { useTranslate } from '@im/react-localization';
import Button from '@mui/material/Button';
import React from 'react';
import { UseMutateAsyncFunction } from 'react-query';
import useSnackBar from 'src/hooks/useSnackBar';
import { downloadFile } from 'src/util/downloadFileUtil';
import { WretcherResponse } from 'wretch';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

export function DownloadButton(
  props: Readonly<{
    disabled?: boolean;
    fileName: string;
    mutateAsync: UseMutateAsyncFunction<
      WretcherResponse,
      unknown,
      void,
      unknown
    >;
  }>
) {
  const translate = useTranslate();
  const { showSnackBar } = useSnackBar();
  const { disabled, fileName, mutateAsync } = props;
  return (
    <Button
      data-testid="gds-vp-searchResult-download-btn"
      disabled={disabled}
      onClick={() => {
        showSnackBar({
          autoHide: 'stay',
          message: translate('Common.Downloading'),
          severity: 'info',
        });
        mutateAsync()
          .then((res) => {
            downloadFile(res, fileName);
            showSnackBar({
              autoHide: 2000,
              message: translate('Common.DownloadSuccess'),
              severity: 'success',
            });
          })
          .catch(() => {
            showSnackBar({
              autoHide: 2000,
              message: translate('Common.DownloadError'),
              severity: 'error',
            });
          });
      }}
      startIcon={<FileDownloadOutlinedIcon />}
      variant="newContained"
    >
      {translate('Common.Download')}
    </Button>
  );
}
